//update
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/main.css"; // Tailwind CSS is imported here with important flag
import "./assets/css/theme.css"; // Customer palette tokens + page ground (after main.css so it wins)
import "./assets/css/a11y.css"; // Focus ring, skip link, reduced motion (last so it wins)
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { createStore } from "vuex";
import VueZoomer from 'vue-zoomer'
import { polyfillCountryFlagEmojis } from "country-flag-emoji-polyfill";

// Focus rings are for keyboard users (a11y.css): a pointer press switches to
// "mouse" mode and hides them, pressing Tab switches back.
document.addEventListener("pointerdown", () => {
  document.documentElement.dataset.input = "mouse";
}, true);
document.addEventListener("keydown", (e) => {
  if (e.key === "Tab") delete document.documentElement.dataset.input;
}, true);

// Windows has no flag emoji glyphs (🇺🇸 renders as "US"); this loads a
// flags-only font there and is a no-op on platforms that already draw flags.
polyfillCountryFlagEmojis();


import SplitCarousel from "vue-split-carousel";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import VueToast from 'vue-toast-notification';
import { modules, dataState } from "./store/storeModules.js";

import PriceFormatter from "./plugins/PriceFormatter.js"
import DateFormatter from "./plugins/DateFormatter.js"
import FileSource from "./plugins/FileSource.js"
import Slugerize from "./plugins/Slugerize.js"

import "./icons/iconsSolid.js";
import "./icons/iconsRegular.js";
import "./icons/iconsBrands.js";


// Import one of the available themes
//import 'vue-toast-notification/dist/theme-default.css';
import 'vue-toast-notification/dist/theme-sugar.css';


const Vue = createApp(App);

const store = new createStore({
  modules,
  strict: process.env.NODE_ENV !== "production",
  plugins: [dataState]
});

router.beforeEach((to, from) => {
  // if (to.meta) {
  //   const authorized = localStorage.getItem("token");
  //   let requireLogin = true;
  //   if (to.meta.requiresLogin) {
  //     requireLogin = false;
  //   }

  //   if (!authorized) {
  //     if (requireLogin) {
  //       next({ path: '/' });
  //     }
  //   } else {
  //     next();
  //   }
  // } else {
  //   next();
  // }
  // Only a new page starts at the top: query-only changes (tabs, filters,
  // ?view= on admin pages) keep the user where they are.
  if (to.path !== from.path) window.scrollTo(0, 0)
  store.commit("forceCloseModal")
})

// SPA-aware Meta Pixel + GTM page tracking.
//
// The base Meta Pixel snippet in public/index.html only fires PageView on
// the initial hard page load. Because this app is a Vue SPA, subsequent
// navigations happen client-side and would otherwise be invisible to the
// pixel and to GTM. This afterEach hook fires PageView on every successful
// route change, and also pushes a virtualPageview to dataLayer so GTM can
// mirror it to Google Ads / GA4.
router.afterEach((to) => {
  try {
    if (typeof window === 'undefined') return;

    if (typeof window.fbq === 'function') {
      window.fbq('track', 'PageView');
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'virtualPageview',
      pagePath: to.fullPath,
      pageName: to.name || undefined,
    });
  } catch (e) {
    // Tracking must never break navigation
    console.warn('Page tracking skipped:', e);
  }
})

Vue.use(VueZoomer)
  .use(router)
  .use(store)
  .use(PriceFormatter)
  .use(FileSource)
  .use(VueToast)
  .use(Slugerize)
  .use(DateFormatter)
  .use(SplitCarousel)
  .component("font-awesome-icon", FontAwesomeIcon)
  .mount("#app");

  export default Vue
